import request from '@/config'
import { useAppStoreWithOut } from '@/store/app'

/* Types */
import { DicListSearch, PubDicCreate, PubDicEdit, PubDicDelete, PubDicBase } from './pub.dictionary.type';

const appStore = useAppStoreWithOut()

const enum Apis {
    "DicList" = `/api/pubdictionary/getpubdictionarypage`,
    "Delete" = `/api/pubdictionary/deletepubdictionary'`,
    "Detail" = `/api/pubdictionary/getpubdictionaryinfo`,
    "Create" = `/api/pubdictionary/insertpubdictionary`,
    "Modify" = `/api/pubdictionary/updatepubdictionary`
}

/* 公共数据字典：查询(Detail) */
export const PubDicDetailApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: Apis.Detail, data: { id: rowId } })
}


/* 公共数据字典：查询(List) */
export const GetDicListApi = (searchs: DicListSearch): Promise<IResponse> => {

    return request.post({ url: Apis.DicList, data: searchs })

}

/* 公共数据字典：删除(Delete) */
export const DicDeleteApi = (delInput: PubDicDelete): Promise<IResponse> => {

    return request.post({ url: Apis.Delete, data: delInput })

}

/* 公共数据字典：新增(Create) */
export const PubDicCreateApi = (creaetIpt: PubDicBase): Promise<IResponse> => {


    return request.post({ url: Apis.Create, data: creaetIpt })
}

/* 公共数据字典：修改(Editor) */
export const PubDicEditorApi = (editIpt: PubDicBase): Promise<IResponse> => {

    return request.post({ url: Apis.Modify, data: editIpt })
}

